// extracted by mini-css-extract-plugin
export default {"appShell":"ShellLayout_appShell__J1qLV","header":"ShellLayout_header__VPrXv","navbar":"ShellLayout_navbar__RN5mF","main":"ShellLayout_main__vAp1m"};